import { Box } from '@mui/material';
import * as React from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { JsonView, allExpanded, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

import Service from '../../util/Service';

const json = {
    a: 1,
    b: 'example'
  };

export default function BpmnProcessDataPanel() {
    const params = useParams();

    const [dado, setDado] = React.useState();
    const [index, setIndex] = React.useState(0);



    React.useEffect(() => {
        buscaDado();
    }, []);

    const buscaDado=()=>{
        Service.GET("/api/bpmn/buscaProcessoBGPorProcessoId/"+params.id).then(r =>{
            setDado( r)
        })
    }

    return (
        <Box sx={{ p: 2, border: '1px dashed grey' }}>
            
            <JsonView data={dado} shouldExpandNode={allExpanded} style={defaultStyles} />
            {/* <JsonView data={json} shouldExpandNode={allExpanded} style={darkStyles} /> */}
        </Box>
    )
}